import { render, staticRenderFns } from "./whatnowList.vue?vue&type=template&id=73890a4a&scoped=true"
import script from "./whatnowList.vue?vue&type=script&lang=js"
export * from "./whatnowList.vue?vue&type=script&lang=js"
import style0 from "./whatnowList.vue?vue&type=style&index=0&id=73890a4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73890a4a",
  null
  
)

export default component.exports